<template>
  <div class="excurriculum">
    <div class="campus">电商管理
      <span>></span>
      课程管理
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="header">全部课程</div>
          <el-button type="primary" class="mb-24" @click="newBuildCourse">
            新建课程
          </el-button>
          <div class="class_type">
            <div class="item">
              <span>置顶推荐：</span>
              <el-select v-model="stick" @change="getcourselist" clearable>
                <el-option v-for="(item,index) in stickList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="item">
              <span>课程类型：</span>
              <el-select v-model="classtypes" @change="getcourselist" clearable>
                <el-option v-for="(item,index) in classType" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="item">
              <span>创建时间：</span>
              <el-date-picker v-model="value1" type="datetimerange" range-separator="至" value-format="yyyy-MM-dd hh:mm:ss"
                start-placeholder="开始日期" end-placeholder="结束日期" @change="getcourselist">
              </el-date-picker>
            </div>
            <div class="dz-flex  dz-flex-align-center item">
              <span>课程名称：</span>
              <span>
                <el-input v-model="searchName" clearable @keyup.13.native="getcourselist" placeholder="请输入课程名称"></el-input>
              </span>
              <el-button type="primary" class="buttons ml-20" @click="getcourselist">查 询</el-button>
            </div>
          </div>

          <div class="tableStyle">
            <el-table :data="tableData" @selection-change="handleSelectionChange" style="width: 100%">
              <el-table-column prop="name" label="课程名称" align="center">
              </el-table-column>
              <el-table-column prop="createDate" label="创建时间" align="center">
              </el-table-column>
              <el-table-column prop="typeStr" label="课程类型" align="center">
              </el-table-column>
              <el-table-column prop="topNo" label="是否置顶" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.topNo" active-color="#13ce66" inactive-color="#ff4949" @change="stickYesOrNo(scope.row)">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="labels" label="课程标签" align="center">
                <template slot-scope="scope">
                  <span v-for="(item,index) in scope.row.labels" :key="index">
                    <span class="course_label" :style="{'background':item.backgroundColor,'color':item.fontColor}">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="lookcourse(scope.row)">查看课程</el-button>
                  <el-button type="text" @click="lookcourses(scope.row)">编辑</el-button>
                  <el-button type="text" @click="deletcourse(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dz-flex dz-flex-justify-end mt-12">
            <el-pagination background @size-change="getcourselist" @current-change="getcourselist" :current-page.sync="page"
              :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
    <!-- 会话框 -->
    <div class="dialogStyle">
      <!-- 新建,编辑课程 -->
      <el-dialog :title="dialogType ? '编辑课程':'新增课程'" :visible.sync="publicDialog" width="1000px" center>
        <el-form ref="forms" :model="forms" :rules="FormRules" label-width="120px">
          <el-form-item label="课程名称:" prop="name">
            <el-input v-model="forms.name" placeholder="请输入课程名称"></el-input>
          </el-form-item>
          <el-form-item label="课程类型:" prop="abbreviation">
            <el-select v-model="forms.abbreviation" @change="onSelectedDrug($event)">
              <el-option v-for="(item) in typeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程标签:" prop="discount">
            <el-select v-model="forms.abbreviation" @change="onSelectedDrug($event)">
              <el-option v-for="(item) in typeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程简介:" prop="shortname">
            <el-input type="textarea" v-model="forms.shortname" placeholder="请输入课程简介" resize="none"></el-input>
          </el-form-item>
          <el-form-item label="课程价格:" prop="price">
            <el-input v-model="forms.price" placeholder="请输入价格" @onkeyup="this.value=this.value.replace(/[^0-9,.]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="课程折扣:" prop="discount">
            <el-input v-model="forms.discount" placeholder="请输入折扣,输入0-1之间的数字" @onkeyup="this.value=this.value.replace(/[^0-9,.]/g,'')">
            </el-input>
          </el-form-item>
          <el-form-item label="折扣价格:" prop="discountPrice">
            <el-input v-model="forms.discountPrice" placeholder="请输入折扣价格，折扣价格优先级高于课程折扣"
              @onkeyup="this.value=this.value.replace(/[^0-9,.]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label=" 课程数量:" prop="seqnum">
            <el-input-number v-model="forms.seqnum" :min="1" :max="99999999" @onkeyup="this.value=this.value.replace(/[^0-9]/g,'')">
            </el-input-number>
          </el-form-item>
          <el-form-item label="课程详情:" prop="coursedetails">
            <el-input type="textarea" v-model="forms.details" placeholder="请输入课程详情" resize="none">
            </el-input>
          </el-form-item>
          <el-form-item label=" 课程热度:" prop="classhot">
            <el-input-number v-model="forms.hot" :min="1" :max="99999999" @onkeyup="this.value=this.value.replace(/[^0-9]/g,'')">
            </el-input-number>
          </el-form-item>
          <el-form-item label="课程封面:" prop="picurl">
            <el-upload class="avatar-uploader" action="#" :auto-upload="false" v-model="forms.picurl" :show-file-list="false"
              :on-change="collectlist">
              <el-button type="primary" size="samll">更换图片</el-button>
              <div v-show="forms.picurl">
                <img :src="forms.picurl" class="avatar mt-10" />
              </div>
            </el-upload>
            <div class="jianyi">
              <span>( 建议：JPG或PNG图片， 推荐：400*400)</span>
            </div>
          </el-form-item>
          <el-form-item label="视频介绍:" prop="videoUrl">
            <el-upload class="avatar-uploader" action="#" :auto-upload="false" v-model="forms.videourl" :show-file-list="false"
              :on-change="uploadvadio">
              <el-button type="primary" size="samll">添加视频</el-button>
              <div v-show="forms.videoUrl">
              </div>
            </el-upload>
            <video class="avatar mt-10" :src="forms.videoUrl" autoplay></video>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="publicDialog = false">取 消</el-button>
          <el-button type="primary" @click="addcourse">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const FormRules = {
  name: [
    {
      required: true,
      message: '请输入课程名称',
      trigger: ['blur', 'change'],
    },
  ],
  price: [
    {
      required: true,
      message: '请输入价格',
      trigger: ['blur', 'change'],
    },
  ],
  seqnum: [
    {
      required: true,
      message: '请选择或输入数量',
      trigger: ['blur', 'change'],
    },
  ],
  abbreviation: [
    {
      required: true,
      message: '请选择类型',
      trigger: ['blur', 'change'],
    },
  ],
};
export default {
  data() {
    return {
      value1: '',
      FormRules,
      searchName: '',
      tableData: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 10,
      total: 0,
      stickList: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '置顶',
          value: true,
        },
        {
          label: '不置顶',
          value: false,
        },
      ],
      stick: '',
      classtypes: '',
      classType: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '综合课程',
          value: '1',
        },
        {
          label: '专项课程',
          value: '2',
        },
      ],
      chooseClass: [],
      typeList: [
        {
          value: '综合课程标签',
          id: 1,
        },
        {
          value: '专项课程标签',
          id: 2,
        },
      ],
      publicDialog: false,
      secondkillDialog: false,
      sceondkillId: '',
      dialogType: '',

      typeLabelValue: '',
      forms: {
        abbreviation: '',
        name: '',
        price: '',
        details: '',
        seqnum: '',
        picurl: '',
        videoUrl: '',
        hot: '',
        discount: '',
        discountPrice: '',
      },
      form: {
        date1: '',
        date2: '',
        skillprice: '',
      },
    };
  },
  created() {
    this.getcourselist();
  },
  methods: {
    //添加课程
    addcourse() {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course',
        method: 'POST',
        data: {
          name: this.forms.name,
          price: this.forms.price,
          stock: this.forms.seqnum,
          type: this.typeLabelValue,
          coverUrl: this.forms.picurl,
          detail: this.forms.details,
          hot: this.forms.hot,
          discount: this.forms.discount,
          discountPrice: this.forms.discountPrice,
          videoUrl: this.forms.videoUrl,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result, 'sas');
          if (result.data.code === 0) {
            this.getcourselist();
            this.publicDialog = false;
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('添加失败：' + err);
        });
    },
    stickYesOrNo(row) {
      // console.log(row);
      if (row.topNo === true) {
        let orgid = window.sessionStorage.getItem('orgid');
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let pro = this.$http({
          url: '/edu/mall/course/top/' + row.id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result, 'sas');
            if (result.data.code === 0) {
              this.$message.success('设置成功！');
            }
            // this.getcourselist();
          })
          .catch((err) => {
            // console.log('error===============')
            this.$message.error('设置失败：' + err);
          });
      } else {
        let orgid = window.sessionStorage.getItem('orgid');
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let pro = this.$http({
          url: '/edu/mall/course/top/' + row.id + '/del',
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result, 'sas');
            if (result.data.code === 0) {
              this.$message.success('取消成功！');
            }
            // this.getcourselist();
          })
          .catch((err) => {
            // console.log('error===============')
            this.$message.error('取消失败：' + err);
          });
      }
    },
    //删除课程
    deletcourse(row) {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let pro = this.$http({
          url: '/edu/mall/course/' + row.id + '/del',
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result, 'sas');
            if (result.data.code === 0) {
              this.$message.success('删除成功！');
              this.getcourselist();
            }
          })
          .catch((err) => {
            // console.log('error===============')
            this.$message.error('添加失败：' + err);
          });
      });
    },
    //新建课程
    newBuildCourse() {
      this.$router.push('catalogue');
    },
    //查询列表
    getcourselist() {
      if (!this.value1) {
        this.value1 = [];
      }
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/courses?' + 'page=' + this.page + '&pageSize=' + this.pageSize,
        params: {
          courseType: this.classtypes,
          name: this.searchName,
          beginDate: this.value1[0],
          endDate: this.value1[1],
          topNo: this.stick,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'sas');
          if (result.data.code === 0) {
            this.tableData = result.data.data;
            this.total = result.data.size;
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('查询失败' + err);
        });
    },
    //添加至免费课程
    addMyclass() {
      // console.log(this.chooseClass, 'aaaa');
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/free',
        method: 'POST',
        data: this.chooseClass,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result, 'sas');
          if (this.chooseClass === '') {
            return this.$message.error('您尚未添加书籍!');
          } else if (result.data.code === 0) {
            this.$message.success('添加成功！');
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('添加失败：' + err);
        });
    },

    //............添加至秒杀
    sceondkill(row) {
      this.sceondkillId = row.id;
      this.secondkillDialog = true;
    },
    //提交秒杀
    submitkill() {
      // console.log(this.sceondkillId, this.form.date1, this.form.date2, this.form.skillprice, 'aaaa');
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/seckill/' + this.sceondkillId + '/add',
        method: 'POST',
        data: {
          beginTime: this.form.date1,
          endTime: this.form.date2,
          seckillPrice: Number(this.form.skillprice),
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result, 'sas');
          if (result.data.code === 0) {
            this.$message.success('添加成功！');
            this.secondkillDialog = false;
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('添加失败：' + err);
        });
    },

    //查看课程
    lookcourses(row) {
      // console.log(row);
      this.$router.push({ path: '/catalogue', query: { id: row.id } });
    },
    lookcourse(row) {
      // console.log(row);
      this.$router.push({ path: '/newcourse', query: { id: row.id } });
    },
    //上传图片
    collectlist(data) {
      // console.log(data, 'asdad');
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.raw);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result);
          if (result.data.code === 0) {
            this.$set(this.forms, 'picurl', result.data.data);
            // console.log(this.forms.picurl, 'asad');
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
    //上传视频
    uploadvadio(data) {
      // console.log(data, 'asdad');
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('video', data.raw);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadVideo',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result);
          if (result.data.code === 0) {
            this.$set(this.forms, 'videoUrl', result.data.data);
            // console.log(this.forms.videoUrl, 'asad');
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传视频错误：' + err);
        });
    },
    //选择
    handleSelectionChange: function (val) {
      var id = [];
      for (let i = 0; i < val.length; i++) {
        // console.log(val[i].id);
        id.push(val[i].id);
      }
      // console.log(id, 'ssss');
      this.chooseClass = id;
      // console.log(val,"ahahah");
    },
    onSelectedDrug(e) {
      // console.log(e, 'value?');
      this.typeLabelValue = e;
    },
  },
};
</script>

<style lang="less" scoped>
.excurriculum {
  .jianyi {
    font-size: 12px !important;
    color: #cccccc;
    position: absolute;
    top: 0;
    left: 135px;
  }
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
  .avatar-uploader {
    img {
      width: 120px;
      height: 120px;
    }
  }
  .class_type {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 0 20px 0;
    .item {
      margin: 0 20px 20px 0;
    }
  }
  /deep/.el-upload {
    text-align: left;
  }
  .tableImg {
    width: 80px;
    height: 80px;
  }
  /deep/.el-card__body {
    padding: 0 1.3vw;
  }
  .course_label {
    display: inline-block;
    margin: 3px 5px;
    padding: 0 10px;
  }
}
</style>
